import { renderLucideIcon } from '../utils/lucide-icons.js'

function normalizeTokenQuotaState(input) {
  var blocked = Boolean(input && input.blocked)
  var reason = input && input.reason ? String(input.reason) : null
  var message = input && input.message ? String(input.message) : ''

  return {
    blocked: blocked,
    reason: reason,
    message: message,
    includedBalanceCredits: normalizeCreditAmount(input && (input.includedBalanceCredits ?? input.includedBalanceTokens)),
    additionalBalanceCredits: normalizeCreditAmount(input && (input.additionalBalanceCredits ?? input.additionalBalanceTokens)),
    totalBalanceCredits: normalizeCreditAmount(input && (input.totalBalanceCredits ?? input.totalBalanceTokens)),
    includedBalanceTokens: normalizeTokenCount(input && input.includedBalanceTokens),
    additionalBalanceTokens: normalizeTokenCount(input && input.additionalBalanceTokens),
    totalBalanceTokens: normalizeTokenCount(input && input.totalBalanceTokens)
  }
}

function renderTokenQuotaNotice(state, translations) {
  var normalized = normalizeTokenQuotaState(state)
  if (!normalized.blocked) return ''

  var text = normalized.message || (translations && translations.exhaustedMessage) || "Le quota de crédits de votre organisation est épuisé."
  return [
    '<div class="wc-token-quota-notice" role="status" aria-live="polite">',
    '<span class="wc-token-quota-notice-icon">',
    renderLucideIcon('badgeInfo'),
    '</span>',
    '<span>',
    escapeHtml(text),
    '</span>',
    '</div>'
  ].join('')
}

function normalizeTokenCount(value) {
  var normalized = Number(value || 0)
  if (!Number.isFinite(normalized) || normalized < 0) return 0
  return Math.trunc(normalized)
}

function normalizeCreditAmount(value) {
  var normalized = Number(value || 0)
  if (!Number.isFinite(normalized) || normalized < 0) return 0
  return Math.round((normalized + Number.EPSILON) * 1000000) / 1000000
}

function escapeHtml(value) {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

export { normalizeTokenQuotaState, renderTokenQuotaNotice }
